import React from 'react';

export default () => (
  <div className="footer" />
);



// WEBPACK FOOTER //
// ./src/Shared/Helpers/Footer.js